module.exports = __webpack_public_path__ + "img/paper-8.22f61f15.png";